import React, { useState } from 'react';
import { Layout } from '../components/Layout';
import { Card } from '../components/ui/Card';
import { Badge } from '../components/ui/Badge';
import { Button } from '../components/ui/Button';
import { Select } from '../components/ui/Select';
import { DatePicker } from '../components/ui/DatePicker';
import { StatCard } from '../components/ui/StatCard';
import { Modal } from '../components/ui/Modal';
import { Input } from '../components/ui/Input';
import { ColumnCustomizer } from '../components/ColumnCustomizer';
import { useNavigate } from 'react-router-dom';
import { TrendingUp, Users, AlertCircle, Clock, CheckCircle2, Receipt, Calendar, Download, Target, FileText, PieChart, Euro, Plus, Edit, Trash2, Eye } from 'lucide-react';
import { LineChart, Line, BarChart as RechartsBarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, PieChart as RechartsPieChart, Pie, Cell, AreaChart, Area, ComposedChart } from 'recharts';
type TabType = 'operativa' | 'commerciale' | 'economica' | 'obiettivi';
// Mock Data for Charts
const trendData = [{
  name: 'Gen',
  preventivi: 40000,
  positivi: 24000
}, {
  name: 'Feb',
  preventivi: 30000,
  positivi: 13980
}, {
  name: 'Mar',
  preventivi: 20000,
  positivi: 9800
}, {
  name: 'Apr',
  preventivi: 27800,
  positivi: 3908
}, {
  name: 'Mag',
  preventivi: 18900,
  positivi: 4800
}, {
  name: 'Giu',
  preventivi: 23900,
  positivi: 3800
}];
const salesRepData = [{
  name: 'Alessio',
  positivi: 12000,
  target: 10000
}, {
  name: 'Lorenzo',
  positivi: 15000,
  target: 12000
}, {
  name: 'Gian Franco',
  positivi: 8000,
  target: 10000
}, {
  name: 'Tiziano',
  positivi: 9500,
  target: 9000
}];
const conversionData = [{
  name: 'Positivi',
  value: 65
}, {
  name: 'Negativi',
  value: 15
}, {
  name: 'In valutazione',
  value: 20
}];
const COLORS = ['#10B981', '#EF4444', '#F59E0B'];
const revenueData = [{
  name: 'Gen',
  fatturato: 45000,
  proformato: 12000,
  target: 50000
}, {
  name: 'Feb',
  fatturato: 52000,
  proformato: 8000,
  target: 50000
}, {
  name: 'Mar',
  fatturato: 48000,
  proformato: 15000,
  target: 50000
}, {
  name: 'Apr',
  fatturato: 61000,
  proformato: 5000,
  target: 55000
}, {
  name: 'Mag',
  fatturato: 55000,
  proformato: 10000,
  target: 55000
}, {
  name: 'Giu',
  fatturato: 59000,
  proformato: 12000,
  target: 60000
}];
const objectivesData = [{
  id: 1,
  month: 'Gennaio',
  targetSales: 10000,
  actualSales: 12500,
  targetRevenue: 40000,
  actualRevenue: 38000
}, {
  id: 2,
  month: 'Febbraio',
  targetSales: 10000,
  actualSales: 9800,
  targetRevenue: 40000,
  actualRevenue: 41200
}, {
  id: 3,
  month: 'Marzo',
  targetSales: 12000,
  actualSales: 15000,
  targetRevenue: 45000,
  actualRevenue: 48000
}, {
  id: 4,
  month: 'Aprile',
  targetSales: 12000,
  actualSales: 11000,
  targetRevenue: 45000,
  actualRevenue: 42000
}, {
  id: 5,
  month: 'Maggio',
  targetSales: 15000,
  actualSales: 18000,
  targetRevenue: 50000,
  actualRevenue: 52000
}, {
  id: 6,
  month: 'Giugno',
  targetSales: 15000,
  actualSales: 16500,
  targetRevenue: 50000,
  actualRevenue: 51000
}];
const topClientsData = [{
  name: 'Metalmeccanica Rossi SRL',
  amount: '€ 25.400',
  perc: '8.5%'
}, {
  name: 'Edilizia Moderna SPA',
  amount: '€ 18.200',
  perc: '6.1%'
}, {
  name: 'Supermercati Market',
  amount: '€ 15.100',
  perc: '5.0%'
}, {
  name: 'Ristorante Da Mario',
  amount: '€ 12.800',
  perc: '4.2%'
}, {
  name: 'Studio Legale Bianchi',
  amount: '€ 9.500',
  perc: '3.1%'
}, {
  name: 'Autofficina Veloce',
  amount: '€ 8.200',
  perc: '2.7%'
}, {
  name: 'Bar Centrale',
  amount: '€ 7.100',
  perc: '2.4%'
}, {
  name: 'Farmacia Salute',
  amount: '€ 6.800',
  perc: '2.3%'
}, {
  name: 'Hotel Bellavista',
  amount: '€ 5.900',
  perc: '2.0%'
}, {
  name: 'Panificio Dolce',
  amount: '€ 4.500',
  perc: '1.5%'
}];
const allActivities = [{
  user: 'Alessio',
  action: 'ha creato un nuovo contratto',
  target: 'Metalmeccanica Rossi SRL',
  date: '2 ore fa',
  icon: CheckCircle2,
  bg: 'bg-green-100',
  text: 'text-green-600'
}, {
  user: 'Lorenzo',
  action: 'ha completato il sopralluogo',
  target: 'Ristorante Da Mario',
  date: '4 ore fa',
  icon: CheckCircle2,
  bg: 'bg-blue-100',
  text: 'text-blue-600'
}, {
  user: 'Tiziano',
  action: 'ha segnalato una non conformità',
  target: 'Edilizia Moderna',
  date: 'Ieri',
  icon: AlertCircle,
  bg: 'bg-red-100',
  text: 'text-red-600'
}, {
  user: 'Amministrazione',
  action: 'ha emesso fattura #2024/45',
  target: 'Studio Legale Bianchi',
  date: 'Ieri',
  icon: Receipt,
  bg: 'bg-yellow-100',
  text: 'text-yellow-600'
}, {
  user: 'Gian Franco',
  action: 'ha aggiornato il DVR',
  target: 'Supermercati Market',
  date: '2 giorni fa',
  icon: FileText,
  bg: 'bg-purple-100',
  text: 'text-purple-600'
}, {
  user: 'Alessio',
  action: 'ha pianificato corso formazione',
  target: 'Hotel Bellavista',
  date: '3 giorni fa',
  icon: Calendar,
  bg: 'bg-indigo-100',
  text: 'text-indigo-600'
}];
const deadlinesData = [{
  id: 1,
  title: 'Rinnovo DVR',
  client: 'Autofficina Veloce',
  date: 'Domani',
  priority: 'high'
}, {
  id: 2,
  title: 'Corso antincendio',
  client: 'Supermercato Market',
  date: '15/05/2024',
  priority: 'medium'
}, {
  id: 3,
  title: 'Visita medica Rossi Mario',
  client: 'Edilizia Moderna',
  date: '16/05/2024',
  priority: 'medium'
}, {
  id: 4,
  title: 'Scadenza fattura #44',
  client: 'Bar Centrale',
  date: '18/05/2024',
  priority: 'low'
}];
const columnsConfig = [{
  key: 'month',
  label: 'Mese'
}, {
  key: 'targetSales',
  label: 'Obiettivo prev.'
}, {
  key: 'actualSales',
  label: 'Reale prev.'
}, {
  key: 'diffSales',
  label: 'Diff. prev.'
}, {
  key: 'targetRevenue',
  label: 'Obiettivo fatt.'
}, {
  key: 'actualRevenue',
  label: 'Reale fatt.'
}, {
  key: 'diffRevenue',
  label: 'Diff. fatt.'
}];
export function Dashboard() {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState<TabType>('operativa');
  const [period, setPeriod] = useState('month');
  const [customStart, setCustomStart] = useState('');
  const [customEnd, setCustomEnd] = useState('');
  const [showActivitiesModal, setShowActivitiesModal] = useState(false);
  const [showTopClientsModal, setShowTopClientsModal] = useState(false);
  const [showObjectivesModal, setShowObjectivesModal] = useState(false);
  const [showDeadlineViewModal, setShowDeadlineViewModal] = useState(false);
  const [showDeadlineEditModal, setShowDeadlineEditModal] = useState(false);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [selectedDeadline, setSelectedDeadline] = useState<any>(null);
  const [visibleColumns, setVisibleColumns] = useState(columnsConfig.map(c => c.key));
  const userName = 'Alessio';
  const tabs = [{
    id: 'operativa' as TabType,
    label: 'Operativa'
  }, {
    id: 'commerciale' as TabType,
    label: 'Commerciale'
  }, {
    id: 'economica' as TabType,
    label: 'Economica'
  }, {
    id: 'obiettivi' as TabType,
    label: 'Obiettivi'
  }];
  const formatCurrency = (val: number) => `€ ${val.toLocaleString('it-IT')}`;
  const handleDeadlineClick = (item: any) => {
    setSelectedDeadline(item);
    setShowDeadlineViewModal(true);
  };
  const handleDeadlineEdit = (item: any, e: React.MouseEvent) => {
    e.stopPropagation();
    setSelectedDeadline(item);
    setShowDeadlineEditModal(true);
  };
  const handleDeadlineDelete = (item: any, e: React.MouseEvent) => {
    e.stopPropagation();
    setSelectedDeadline(item);
    setShowDeleteConfirm(true);
  };
  const renderOperativa = () => <>
      {/* KPI Cards - Clickable */}
      <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4 mb-8" data-id="element-1349">
        {[{
        name: 'Fatturato mensile',
        value: '€ 45.231',
        change: '+12%',
        changeType: 'positive',
        icon: TrendingUp,
        color: 'bg-blue-500',
        href: '/invoicing'
      }, {
        name: 'Clienti attivi',
        value: '124',
        change: '+4',
        changeType: 'positive',
        icon: Users,
        color: 'bg-green-500',
        href: '/clients'
      }, {
        name: 'Fatture in scadenza',
        value: '8',
        change: '€ 12.400',
        changeType: 'negative',
        icon: AlertCircle,
        color: 'bg-red-500',
        href: '/invoicing'
      }, {
        name: 'Scadenze settimana',
        value: '15',
        change: 'Urgenti: 3',
        changeType: 'neutral',
        icon: Clock,
        color: 'bg-seform-orange',
        href: '/deadlines'
      }].map(kpi => <div key={kpi.name} onClick={() => navigate(kpi.href)} className="bg-white rounded-2xl p-6 shadow-sm border border-slate-100 hover:shadow-md transition-all cursor-pointer relative overflow-hidden group" data-id="element-1350">
            <div className="absolute top-0 right-0 w-24 h-24 bg-gradient-to-br from-white/0 to-slate-50 rounded-bl-full -mr-4 -mt-4 transition-transform group-hover:scale-110" data-id="element-1351"></div>
            <div className="relative z-10" data-id="element-1352">
              <div className="flex justify-between items-start mb-4" data-id="element-1353">
                <div className={`p-3 rounded-xl ${kpi.color} bg-opacity-10`} data-id="element-1354">
                  <kpi.icon className={`h-6 w-6 ${kpi.name === 'Scadenze settimana' ? 'text-seform-orange' : ''} ${kpi.name === 'Fatturato mensile' ? 'text-blue-600' : ''} ${kpi.name === 'Clienti attivi' ? 'text-green-600' : ''} ${kpi.name === 'Fatture in scadenza' ? 'text-red-600' : ''}`} data-id="element-1355" />
                </div>
                <Badge variant={kpi.changeType === 'positive' ? 'success' : kpi.changeType === 'negative' ? 'danger' : 'neutral'} size="sm" data-id="element-1356">
                  {kpi.change}
                </Badge>
              </div>
              <h3 className="text-slate-500 text-sm font-medium" data-id="element-1357">{kpi.name}</h3>
              <p className="text-2xl font-bold text-seform-navy mt-1" data-id="element-1358">
                {kpi.value}
              </p>
            </div>
          </div>)}
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8" data-id="element-1359">
        {/* Recent Activity */}
        <Card title="Attività recenti" description="Ultime operazioni registrate nel sistema" actions={<Button variant="light" size="sm" onClick={() => setShowActivitiesModal(true)} data-id="element-1361">
              Vedi tutte
            </Button>} data-id="element-1360">
          <div className="flow-root" data-id="element-1362">
            <ul className="-mb-8" data-id="element-1363">
              {allActivities.slice(0, 4).map((activity, activityIdx) => <li key={activityIdx} data-id="element-1364">
                  <div className="relative pb-8" data-id="element-1365">
                    {activityIdx !== 3 && <span className="absolute top-4 left-4 -ml-px h-full w-0.5 bg-slate-100" aria-hidden="true" data-id="element-1366" />}
                    <div className="relative flex space-x-3" data-id="element-1367">
                      <div data-id="element-1368">
                        <span className={`h-8 w-8 rounded-full flex items-center justify-center ring-4 ring-white ${activity.bg}`} data-id="element-1369">
                          <activity.icon className={`h-4 w-4 ${activity.text}`} aria-hidden="true" data-id="element-1370" />
                        </span>
                      </div>
                      <div className="min-w-0 flex-1 pt-1.5 flex justify-between space-x-4" data-id="element-1371">
                        <div data-id="element-1372">
                          <p className="text-sm text-slate-500" data-id="element-1373">
                            <span className="font-semibold text-seform-navy" data-id="element-1374">
                              {activity.user}
                            </span>{' '}
                            {activity.action}{' '}
                            <span className="font-semibold text-seform-navy" data-id="element-1375">
                              {activity.target}
                            </span>
                          </p>
                        </div>
                        <div className="text-right text-xs whitespace-nowrap text-slate-400" data-id="element-1376">
                          {activity.date}
                        </div>
                      </div>
                    </div>
                  </div>
                </li>)}
            </ul>
          </div>
        </Card>

        {/* Upcoming Deadlines */}
        <Card title="Scadenze imminenti" description="Attività da completare nei prossimi 7 giorni" actions={<Button variant="light" size="sm" onClick={() => navigate('/deadlines')} data-id="element-1378">
              Vedi calendario
            </Button>} data-id="element-1377">
          <div className="space-y-3" data-id="element-1379">
            {deadlinesData.map(item => <div key={item.id} onClick={() => handleDeadlineClick(item)} className="flex items-center justify-between p-4 bg-slate-50 rounded-xl border border-slate-100 hover:bg-white hover:shadow-sm transition-all cursor-pointer group" data-id="element-1380">
                <div className="flex items-center gap-3" data-id="element-1381">
                  <div className={`w-2 h-2 rounded-full ${item.priority === 'high' ? 'bg-red-500' : item.priority === 'medium' ? 'bg-yellow-500' : 'bg-blue-500'}`} data-id="element-1382"></div>
                  <div data-id="element-1383">
                    <h4 className="text-sm font-semibold text-seform-navy group-hover:text-seform-orange transition-colors" data-id="element-1384">
                      {item.title}
                    </h4>
                    <p className="text-xs text-slate-500" data-id="element-1385">{item.client}</p>
                  </div>
                </div>
                <div className="flex items-center gap-3" data-id="element-1386">
                  <span className="text-xs font-medium text-slate-500 bg-white px-2 py-1 rounded-md border border-slate-100" data-id="element-1387">
                    {item.date}
                  </span>
                  <div className="flex gap-1 opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-1388">
                    <button onClick={e => handleDeadlineEdit(item, e)} className="p-1.5 rounded-md hover:bg-slate-100 transition-colors" title="Modifica scadenza" data-id="element-1389">
                      <Edit className="h-4 w-4 text-slate-400 hover:text-slate-600" data-id="element-1390" />
                    </button>
                    <button onClick={e => handleDeadlineDelete(item, e)} className="p-1.5 rounded-md hover:bg-slate-100 transition-colors" title="Elimina scadenza" data-id="element-1391">
                      <Trash2 className="h-4 w-4 text-slate-400 hover:text-red-500" data-id="element-1392" />
                    </button>
                  </div>
                </div>
              </div>)}
          </div>
        </Card>
      </div>
    </>;
  const renderCommerciale = () => <>
      {/* Period Filter */}
      <div className="flex flex-wrap gap-3 items-end mb-8" data-id="element-1393">
        <div className="w-40" data-id="element-1394">
          <Select options={[{
          value: 'month',
          label: 'Mese corrente'
        }, {
          value: 'year',
          label: 'Anno corrente'
        }, {
          value: 'custom',
          label: 'Personalizzato'
        }]} value={period} onChange={e => setPeriod(e.target.value)} data-id="element-1395" />
        </div>
        {period === 'custom' && <div className="flex gap-2" data-id="element-1396">
            <DatePicker value={customStart} onChange={e => setCustomStart(e.target.value)} data-id="element-1397" />
            <DatePicker value={customEnd} onChange={e => setCustomEnd(e.target.value)} data-id="element-1398" />
          </div>}
        <Button variant="flat" color="secondary" startContent={<Download className="h-4 w-4" data-id="element-1400" />} data-id="element-1399">
          Esporta report
        </Button>
      </div>

      {/* KPI Cards */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8" data-id="element-1401">
        <StatCard title="Obiettivo preventivi positivi" value="€ 12.500" change="+25% vs Target" trend="up" icon={Target} color="bg-green-500" data-id="element-1402" />
        <StatCard title="Totale preventivato" value="€ 45.200" change="15 Preventivi" trend="neutral" icon={FileText} color="bg-blue-500" data-id="element-1403" />
        <StatCard title="Tasso conversione" value="65%" change="+5% vs Mese sc." trend="up" icon={TrendingUp} color="bg-seform-orange" data-id="element-1404" />
        <StatCard title="Preventivi in valutazione" value="€ 18.400" change="8 Preventivi" trend="neutral" icon={PieChart} color="bg-yellow-500" data-id="element-1405" />
      </div>

      {/* Charts */}
      <div className="space-y-8" data-id="element-1406">
        <Card title="Trend preventivi vs positivi" className="min-h-[400px]" data-id="element-1407">
          <div className="h-[300px] w-full mt-6" data-id="element-1408">
            <ResponsiveContainer width="100%" height="100%" data-id="element-1409">
              <LineChart data={trendData} data-id="element-1410">
                <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#E2E8F0" data-id="element-1411" />
                <XAxis dataKey="name" axisLine={false} tickLine={false} tick={{
                fill: '#64748B'
              }} dy={10} data-id="element-1412" />
                <YAxis axisLine={false} tickLine={false} tick={{
                fill: '#64748B'
              }} data-id="element-1413" />
                <Tooltip contentStyle={{
                borderRadius: '8px',
                border: 'none',
                boxShadow: '0 4px 6px -1px rgb(0 0 0 / 0.1)'
              }} data-id="element-1414" />
                <Legend wrapperStyle={{
                paddingTop: '20px'
              }} data-id="element-1415" />
                <Line type="monotone" dataKey="preventivi" stroke="#94A3B8" strokeWidth={2} dot={false} name="Totale preventivato" data-id="element-1416" />
                <Line type="monotone" dataKey="positivi" stroke="#FF9500" strokeWidth={2} activeDot={{
                r: 8
              }} name="Positivi" data-id="element-1417" />
              </LineChart>
            </ResponsiveContainer>
          </div>
        </Card>

        <div className="h-px bg-slate-200" data-id="element-1418"></div>

        <Card title="Performance per commerciale" className="min-h-[400px]" data-id="element-1419">
          <div className="h-[300px] w-full mt-6" data-id="element-1420">
            <ResponsiveContainer width="100%" height="100%" data-id="element-1421">
              <RechartsBarChart data={salesRepData} layout="vertical" data-id="element-1422">
                <CartesianGrid strokeDasharray="3 3" horizontal={false} stroke="#E2E8F0" data-id="element-1423" />
                <XAxis type="number" axisLine={false} tickLine={false} tick={{
                fill: '#64748B'
              }} data-id="element-1424" />
                <YAxis dataKey="name" type="category" axisLine={false} tickLine={false} tick={{
                fill: '#64748B'
              }} width={100} data-id="element-1425" />
                <Tooltip cursor={{
                fill: '#F1F5F9'
              }} data-id="element-1426" />
                <Legend wrapperStyle={{
                paddingTop: '20px'
              }} data-id="element-1427" />
                <Bar dataKey="positivi" fill="#FF9500" radius={[0, 4, 4, 0]} name="Positivi (€)" barSize={20} data-id="element-1428" />
                <Bar dataKey="target" fill="#CBD5E1" radius={[0, 4, 4, 0]} name="Target (€)" barSize={20} data-id="element-1429" />
              </RechartsBarChart>
            </ResponsiveContainer>
          </div>
        </Card>

        <div className="h-px bg-slate-200" data-id="element-1430"></div>

        <Card title="Stato preventivi" data-id="element-1431">
          <div className="h-[280px] w-full relative" data-id="element-1432">
            <ResponsiveContainer width="100%" height="100%" data-id="element-1433">
              <RechartsPieChart data-id="element-1434">
                <Pie data={conversionData} cx="50%" cy="45%" innerRadius={60} outerRadius={80} paddingAngle={5} dataKey="value" data-id="element-1435">
                  {conversionData.map((entry, index) => <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} style={{
                  outline: 'none'
                }} data-id="element-1436" />)}
                </Pie>
                <Tooltip wrapperStyle={{
                zIndex: 100
              }} data-id="element-1437" />
                <Legend verticalAlign="bottom" height={50} wrapperStyle={{
                paddingTop: '20px'
              }} data-id="element-1438" />
              </RechartsPieChart>
            </ResponsiveContainer>
            <div className="absolute top-[45%] left-1/2 transform -translate-x-1/2 -translate-y-1/2 text-center pointer-events-none flex flex-col items-center justify-center" data-id="element-1439">
              <p className="text-3xl font-bold text-seform-navy leading-none" data-id="element-1440">
                45
              </p>
              <p className="text-xs text-slate-500 mt-1" data-id="element-1441">Totali</p>
            </div>
          </div>
          <div className="mt-4 space-y-3" data-id="element-1442">
            <div className="flex justify-between items-center p-2 bg-green-50 rounded-lg" data-id="element-1443">
              <span className="text-sm font-medium text-green-700" data-id="element-1444">
                Positivi
              </span>
              <span className="font-bold text-green-700" data-id="element-1445">€ 24.500</span>
            </div>
            <div className="flex justify-between items-center p-2 bg-yellow-50 rounded-lg relative z-10" data-id="element-1446">
              <span className="text-sm font-medium text-yellow-700" data-id="element-1447">
                In valutazione
              </span>
              <span className="font-bold text-yellow-700" data-id="element-1448">€ 12.200</span>
            </div>
            <div className="flex justify-between items-center p-2 bg-red-50 rounded-lg relative z-10" data-id="element-1449">
              <span className="text-sm font-medium text-red-700" data-id="element-1450">Negativi</span>
              <span className="font-bold text-red-700" data-id="element-1451">€ 8.500</span>
            </div>
          </div>
        </Card>
      </div>
    </>;
  const renderEconomica = () => <>
      {/* Period Filter */}
      <div className="flex flex-wrap gap-3 items-end mb-8" data-id="element-1452">
        <div className="w-40" data-id="element-1453">
          <Select options={[{
          value: 'month',
          label: 'Mese corrente'
        }, {
          value: 'year',
          label: 'Anno corrente'
        }, {
          value: 'custom',
          label: 'Personalizzato'
        }]} value={period} onChange={e => setPeriod(e.target.value)} data-id="element-1454" />
        </div>
        {period === 'custom' && <div className="flex gap-2" data-id="element-1455">
            <DatePicker value={customStart} onChange={e => setCustomStart(e.target.value)} data-id="element-1456" />
            <DatePicker value={customEnd} onChange={e => setCustomEnd(e.target.value)} data-id="element-1457" />
          </div>}
        <Button variant="flat" color="secondary" startContent={<Download className="h-4 w-4" data-id="element-1459" />} data-id="element-1458">
          Esporta report
        </Button>
      </div>

      {/* KPI Cards */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8" data-id="element-1460">
        <StatCard title="Fatturato emesso" value="€ 59.000" change="+8% vs Mese sc." trend="up" icon={Euro} color="bg-seform-navy" data-id="element-1461" />
        <StatCard title="Proformato" value="€ 12.000" change="5 Proforme" trend="neutral" icon={Receipt} color="bg-blue-500" data-id="element-1462" />
        <StatCard title="Totale produzione" value="€ 71.000" change="118% del Target" trend="up" icon={TrendingUp} color="bg-green-500" data-id="element-1463" />
        <StatCard title="Da incassare" value="€ 24.500" change="3 Scadute" trend="down" icon={AlertCircle} color="bg-red-500" data-id="element-1464" />
      </div>

      {/* Main Chart */}
      <Card title="Andamento fatturato vs target" className="mb-8 min-h-[450px]" data-id="element-1465">
        <div className="h-[350px] w-full mt-6" data-id="element-1466">
          <ResponsiveContainer width="100%" height="100%" data-id="element-1467">
            <AreaChart data={revenueData} data-id="element-1468">
              <defs data-id="element-1469">
                <linearGradient id="colorFatturato" x1="0" y1="0" x2="0" y2="1" data-id="element-1470">
                  <stop offset="5%" stopColor="#2D1B69" stopOpacity={0.8} data-id="element-1471" />
                  <stop offset="95%" stopColor="#2D1B69" stopOpacity={0} data-id="element-1472" />
                </linearGradient>
                <linearGradient id="colorProformato" x1="0" y1="0" x2="0" y2="1" data-id="element-1473">
                  <stop offset="5%" stopColor="#3B82F6" stopOpacity={0.8} data-id="element-1474" />
                  <stop offset="95%" stopColor="#3B82F6" stopOpacity={0} data-id="element-1475" />
                </linearGradient>
              </defs>
              <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#E2E8F0" data-id="element-1476" />
              <XAxis dataKey="name" axisLine={false} tickLine={false} tick={{
              fill: '#64748B'
            }} dy={10} data-id="element-1477" />
              <YAxis axisLine={false} tickLine={false} tick={{
              fill: '#64748B'
            }} data-id="element-1478" />
              <Tooltip contentStyle={{
              borderRadius: '8px',
              border: 'none',
              boxShadow: '0 4px 6px -1px rgb(0 0 0 / 0.1)'
            }} data-id="element-1479" />
              <Legend wrapperStyle={{
              paddingTop: '20px'
            }} data-id="element-1480" />
              <Area type="monotone" dataKey="fatturato" stroke="#2D1B69" fillOpacity={1} fill="url(#colorFatturato)" name="Fatturato (€)" data-id="element-1481" />
              <Area type="monotone" dataKey="proformato" stroke="#3B82F6" fillOpacity={1} fill="url(#colorProformato)" name="Proformato (€)" data-id="element-1482" />
              <Area type="monotone" dataKey="target" stroke="#94A3B8" strokeDasharray="5 5" fill="none" name="Target (€)" data-id="element-1483" />
            </AreaChart>
          </ResponsiveContainer>
        </div>
      </Card>

      {/* Breakdown Grid */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8" data-id="element-1484">
        <Card title="Analisi incassi" data-id="element-1485">
          <div className="space-y-6" data-id="element-1486">
            <div data-id="element-1487">
              <div className="flex justify-between mb-1" data-id="element-1488">
                <span className="text-sm font-medium text-slate-700" data-id="element-1489">
                  Incassato (70%)
                </span>
                <span className="text-sm font-medium text-slate-700" data-id="element-1490">
                  € 41.300
                </span>
              </div>
              <div className="w-full bg-slate-200 rounded-full h-2.5" data-id="element-1491">
                <div className="bg-green-600 h-2.5 rounded-full" style={{
                width: '70%'
              }} data-id="element-1492"></div>
              </div>
            </div>
            <div data-id="element-1493">
              <div className="flex justify-between mb-1" data-id="element-1494">
                <span className="text-sm font-medium text-slate-700" data-id="element-1495">
                  In scadenza (20%)
                </span>
                <span className="text-sm font-medium text-slate-700" data-id="element-1496">
                  € 11.800
                </span>
              </div>
              <div className="w-full bg-slate-200 rounded-full h-2.5" data-id="element-1497">
                <div className="bg-yellow-400 h-2.5 rounded-full" style={{
                width: '20%'
              }} data-id="element-1498"></div>
              </div>
            </div>
            <div data-id="element-1499">
              <div className="flex justify-between mb-1" data-id="element-1500">
                <span className="text-sm font-medium text-slate-700" data-id="element-1501">
                  Scaduto (10%)
                </span>
                <span className="text-sm font-medium text-slate-700" data-id="element-1502">
                  € 5.900
                </span>
              </div>
              <div className="w-full bg-slate-200 rounded-full h-2.5" data-id="element-1503">
                <div className="bg-red-500 h-2.5 rounded-full" style={{
                width: '10%'
              }} data-id="element-1504"></div>
              </div>
            </div>
          </div>
          <div className="mt-6 pt-6 border-t border-slate-100 flex justify-end" data-id="element-1505">
            <Button variant="light" color="primary" onClick={() => navigate('/invoicing')} data-id="element-1506">
              Vedi scadenziario completo
            </Button>
          </div>
        </Card>

        <Card title="Top clienti (fatturato da inizio anno)" actions={<Button variant="light" size="sm" onClick={() => setShowTopClientsModal(true)} data-id="element-1508">
              Vedi tutti
            </Button>} data-id="element-1507">
          <div className="overflow-x-auto" data-id="element-1509">
            <table className="w-full text-left" data-id="element-1510">
              <thead data-id="element-1511">
                <tr className="text-xs text-slate-500 uppercase border-b border-slate-100" data-id="element-1512">
                  <th className="pb-3 font-semibold" data-id="element-1513">Cliente</th>
                  <th className="pb-3 font-semibold text-right" data-id="element-1514">Fatturato</th>
                  <th className="pb-3 font-semibold text-right" data-id="element-1515">% Totale</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-slate-50" data-id="element-1516">
                {topClientsData.slice(0, 5).map((client, i) => <tr key={i} data-id="element-1517">
                    <td className="py-3 text-sm font-medium text-seform-navy" data-id="element-1518">
                      {client.name}
                    </td>
                    <td className="py-3 text-sm text-right text-slate-600" data-id="element-1519">
                      {client.amount}
                    </td>
                    <td className="py-3 text-sm text-right text-slate-500" data-id="element-1520">
                      {client.perc}
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>
        </Card>
      </div>
    </>;
  const renderObiettivi = () => <>
      {/* Period Filter */}
      <div className="flex flex-wrap gap-3 items-end mb-8" data-id="element-1521">
        <div className="w-40" data-id="element-1522">
          <Select options={[{
          value: 'month',
          label: 'Mese corrente'
        }, {
          value: 'year',
          label: 'Anno corrente'
        }, {
          value: 'custom',
          label: 'Personalizzato'
        }]} value={period} onChange={e => setPeriod(e.target.value)} data-id="element-1523" />
        </div>
        {period === 'custom' && <div className="flex gap-2" data-id="element-1524">
            <DatePicker value={customStart} onChange={e => setCustomStart(e.target.value)} data-id="element-1525" />
            <DatePicker value={customEnd} onChange={e => setCustomEnd(e.target.value)} data-id="element-1526" />
          </div>}
        <Button variant="flat" color="secondary" startContent={<Download className="h-4 w-4" data-id="element-1528" />} data-id="element-1527">
          Esporta
        </Button>
        <Button onClick={() => setShowObjectivesModal(true)} startContent={<Plus className="h-4 w-4" data-id="element-1530" />} data-id="element-1529">
          Imposta obiettivi
        </Button>
      </div>

      {/* Summary Cards */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8" data-id="element-1531">
        <Card title="Preventivi positivi da inizio anno" data-id="element-1532">
          <div className="flex items-end justify-between" data-id="element-1533">
            <div className="min-w-0 flex-1" data-id="element-1534">
              <p className="text-3xl font-bold text-seform-navy truncate" data-id="element-1535">
                € 82.800
              </p>
              <p className="text-sm text-slate-500 mt-1" data-id="element-1536">Target: € 74.000</p>
            </div>
            <div className="text-right flex-shrink-0 ml-4" data-id="element-1537">
              <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800" data-id="element-1538">
                +11.9%
              </span>
            </div>
          </div>
          <div className="w-full bg-slate-100 rounded-full h-2 mt-4 overflow-hidden" data-id="element-1539">
            <div className="bg-seform-orange h-2 rounded-full" style={{
            width: '100%'
          }} data-id="element-1540"></div>
          </div>
        </Card>
        <Card title="Fatturato da inizio anno" data-id="element-1541">
          <div className="flex items-end justify-between" data-id="element-1542">
            <div className="min-w-0 flex-1" data-id="element-1543">
              <p className="text-3xl font-bold text-seform-navy truncate" data-id="element-1544">
                € 272.200
              </p>
              <p className="text-sm text-slate-500 mt-1" data-id="element-1545">Target: € 270.000</p>
            </div>
            <div className="text-right flex-shrink-0 ml-4" data-id="element-1546">
              <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800" data-id="element-1547">
                +0.8%
              </span>
            </div>
          </div>
          <div className="w-full bg-slate-100 rounded-full h-2 mt-4 overflow-hidden" data-id="element-1548">
            <div className="bg-seform-navy h-2 rounded-full" style={{
            width: '100%'
          }} data-id="element-1549"></div>
          </div>
        </Card>
      </div>

      {/* Charts */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-8" data-id="element-1550">
        <Card title="Preventivi: target vs reale" data-id="element-1551">
          <div className="h-[300px] w-full mt-6" data-id="element-1552">
            <ResponsiveContainer width="100%" height="100%" data-id="element-1553">
              <ComposedChart data={objectivesData} data-id="element-1554">
                <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#E2E8F0" data-id="element-1555" />
                <XAxis dataKey="month" axisLine={false} tickLine={false} tick={{
                fill: '#64748B'
              }} dy={10} data-id="element-1556" />
                <YAxis axisLine={false} tickLine={false} tick={{
                fill: '#64748B'
              }} data-id="element-1557" />
                <Tooltip data-id="element-1558" />
                <Legend wrapperStyle={{
                paddingTop: '20px'
              }} data-id="element-1559" />
                <Bar dataKey="actualSales" fill="#FF9500" name="Reale" barSize={20} radius={[4, 4, 0, 0]} data-id="element-1560" />
                <Line type="monotone" dataKey="targetSales" stroke="#94A3B8" strokeWidth={2} dot={false} name="Target" data-id="element-1561" />
              </ComposedChart>
            </ResponsiveContainer>
          </div>
        </Card>
        <Card title="Fatturato: target vs reale" data-id="element-1562">
          <div className="h-[300px] w-full mt-6" data-id="element-1563">
            <ResponsiveContainer width="100%" height="100%" data-id="element-1564">
              <ComposedChart data={objectivesData} data-id="element-1565">
                <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#E2E8F0" data-id="element-1566" />
                <XAxis dataKey="month" axisLine={false} tickLine={false} tick={{
                fill: '#64748B'
              }} dy={10} data-id="element-1567" />
                <YAxis axisLine={false} tickLine={false} tick={{
                fill: '#64748B'
              }} data-id="element-1568" />
                <Tooltip data-id="element-1569" />
                <Legend wrapperStyle={{
                paddingTop: '20px'
              }} data-id="element-1570" />
                <Bar dataKey="actualRevenue" fill="#2D1B69" name="Reale" barSize={20} radius={[4, 4, 0, 0]} data-id="element-1571" />
                <Line type="monotone" dataKey="targetRevenue" stroke="#94A3B8" strokeWidth={2} dot={false} name="Target" data-id="element-1572" />
              </ComposedChart>
            </ResponsiveContainer>
          </div>
        </Card>
      </div>

      {/* Data Table */}
      <Card noPadding className="overflow-hidden" data-id="element-1573">
        <div className="p-4 flex justify-end border-b border-slate-100" data-id="element-1574">
          <ColumnCustomizer columns={columnsConfig} visibleColumns={visibleColumns} onColumnChange={setVisibleColumns} pageKey="objectives" data-id="element-1575" />
        </div>
        <div className="overflow-x-auto" data-id="element-1576">
          <table className="w-full text-left border-collapse" data-id="element-1577">
            <thead data-id="element-1578">
              <tr className="bg-slate-50/50 border-b border-slate-100 text-xs uppercase tracking-wider text-slate-500 font-semibold" data-id="element-1579">
                {columnsConfig.filter(c => visibleColumns.includes(c.key)).map(col => <th key={col.key} className="px-6 py-4" data-id="element-1580">
                      {col.label}
                    </th>)}
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-100" data-id="element-1581">
              {objectivesData.map(item => {
              const diffSales = item.actualSales - item.targetSales;
              const diffRevenue = item.actualRevenue - item.targetRevenue;
              return <tr key={item.id} className="hover:bg-slate-50/80 transition-colors" data-id="element-1582">
                    {visibleColumns.includes('month') && <td className="px-6 py-4 font-medium text-slate-900" data-id="element-1583">
                        {item.month}
                      </td>}
                    {visibleColumns.includes('targetSales') && <td className="px-6 py-4 text-sm text-slate-600" data-id="element-1584">
                        {formatCurrency(item.targetSales)}
                      </td>}
                    {visibleColumns.includes('actualSales') && <td className="px-6 py-4 text-sm font-bold text-seform-navy" data-id="element-1585">
                        {formatCurrency(item.actualSales)}
                      </td>}
                    {visibleColumns.includes('diffSales') && <td className={`px-6 py-4 text-sm font-medium ${diffSales >= 0 ? 'text-green-600' : 'text-red-600'}`} data-id="element-1586">
                        {diffSales >= 0 ? '+' : ''}
                        {formatCurrency(diffSales)}
                      </td>}
                    {visibleColumns.includes('targetRevenue') && <td className="px-6 py-4 text-sm text-slate-600" data-id="element-1587">
                        {formatCurrency(item.targetRevenue)}
                      </td>}
                    {visibleColumns.includes('actualRevenue') && <td className="px-6 py-4 text-sm font-bold text-seform-navy" data-id="element-1588">
                        {formatCurrency(item.actualRevenue)}
                      </td>}
                    {visibleColumns.includes('diffRevenue') && <td className={`px-6 py-4 text-sm font-medium ${diffRevenue >= 0 ? 'text-green-600' : 'text-red-600'}`} data-id="element-1589">
                        {diffRevenue >= 0 ? '+' : ''}
                        {formatCurrency(diffRevenue)}
                      </td>}
                  </tr>;
            })}
            </tbody>
          </table>
        </div>
      </Card>
    </>;
  return <Layout data-id="element-1590">
      {/* Header */}
      <div className="mb-8 flex flex-col sm:flex-row justify-between items-start sm:items-end gap-4" data-id="element-1591">
        <div data-id="element-1592">
          <h1 className="text-3xl font-bold text-seform-navy" data-id="element-1593">Dashboard</h1>
          <p className="text-slate-500 mt-1" data-id="element-1594">Benvenuto, {userName}.</p>
        </div>
        <div className="flex gap-2" data-id="element-1595">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-slate-100 text-slate-600 rounded-xl text-sm font-medium" data-id="element-1596">
            <Calendar className="h-4 w-4" data-id="element-1597" />
            Oggi: 12 maggio
          </div>
        </div>
      </div>

      {/* Tab Navigation */}
      <div className="mb-8" data-id="element-1598">
        <div className="border-b border-slate-200" data-id="element-1599">
          <nav className="-mb-px flex space-x-8" data-id="element-1600">
            {tabs.map(tab => <button key={tab.id} onClick={() => setActiveTab(tab.id)} className={`py-4 px-1 border-b-2 font-medium text-sm transition-colors ${activeTab === tab.id ? 'border-seform-orange text-seform-orange' : 'border-transparent text-slate-500 hover:text-slate-700 hover:border-slate-300'}`} data-id="element-1601">
                {tab.label}
              </button>)}
          </nav>
        </div>
      </div>

      {/* Tab Content */}
      <div className="transition-opacity duration-200" data-id="element-1602">
        {activeTab === 'operativa' && renderOperativa()}
        {activeTab === 'commerciale' && renderCommerciale()}
        {activeTab === 'economica' && renderEconomica()}
        {activeTab === 'obiettivi' && renderObiettivi()}
      </div>

      {/* Activities Modal */}
      <Modal isOpen={showActivitiesModal} onClose={() => setShowActivitiesModal(false)} title="Tutte le attività recenti" size="lg" data-id="element-1603">
        <div className="space-y-4 max-h-[60vh] overflow-y-auto" data-id="element-1604">
          {allActivities.map((activity, idx) => <div key={idx} className="flex items-start gap-3 p-3 bg-slate-50 rounded-lg" data-id="element-1605">
              <span className={`h-8 w-8 rounded-full flex items-center justify-center flex-shrink-0 ${activity.bg}`} data-id="element-1606">
                <activity.icon className={`h-4 w-4 ${activity.text}`} data-id="element-1607" />
              </span>
              <div className="flex-1 min-w-0" data-id="element-1608">
                <p className="text-sm text-slate-600" data-id="element-1609">
                  <span className="font-semibold text-seform-navy" data-id="element-1610">
                    {activity.user}
                  </span>{' '}
                  {activity.action}{' '}
                  <span className="font-semibold text-seform-navy" data-id="element-1611">
                    {activity.target}
                  </span>
                </p>
                <p className="text-xs text-slate-400 mt-1" data-id="element-1612">{activity.date}</p>
              </div>
            </div>)}
        </div>
      </Modal>

      {/* Top Clients Modal */}
      <Modal isOpen={showTopClientsModal} onClose={() => setShowTopClientsModal(false)} title="Top clienti (fatturato da inizio anno)" size="lg" data-id="element-1613">
        <div className="overflow-x-auto max-h-[60vh]" data-id="element-1614">
          <table className="w-full text-left" data-id="element-1615">
            <thead className="sticky top-0 bg-white" data-id="element-1616">
              <tr className="text-xs text-slate-500 uppercase border-b border-slate-100" data-id="element-1617">
                <th className="pb-3 font-semibold" data-id="element-1618">#</th>
                <th className="pb-3 font-semibold" data-id="element-1619">Cliente</th>
                <th className="pb-3 font-semibold text-right" data-id="element-1620">Fatturato</th>
                <th className="pb-3 font-semibold text-right" data-id="element-1621">% Totale</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-50" data-id="element-1622">
              {topClientsData.map((client, i) => <tr key={i} className="hover:bg-slate-50" data-id="element-1623">
                  <td className="py-3 text-sm text-slate-400" data-id="element-1624">{i + 1}</td>
                  <td className="py-3 text-sm font-medium text-seform-navy" data-id="element-1625">
                    {client.name}
                  </td>
                  <td className="py-3 text-sm text-right text-slate-600" data-id="element-1626">
                    {client.amount}
                  </td>
                  <td className="py-3 text-sm text-right text-slate-500" data-id="element-1627">
                    {client.perc}
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </Modal>

      {/* Objectives Modal */}
      <Modal isOpen={showObjectivesModal} onClose={() => setShowObjectivesModal(false)} title="Imposta obiettivi" size="lg" data-id="element-1628">
        <div className="space-y-6" data-id="element-1629">
          <section data-id="element-1630">
            <h4 className="text-sm font-bold text-seform-navy uppercase tracking-wider mb-4 flex items-center gap-2" data-id="element-1631">
              <Target className="h-4 w-4" data-id="element-1632" /> Obiettivi mensili
            </h4>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-1633">
              <Input label="Mese" type="month" data-id="element-1634" />
              <Input label="Obiettivo preventivi (€)" type="number" data-id="element-1635" />
              <Input label="Obiettivo fatturato (€)" type="number" data-id="element-1636" />
            </div>
          </section>
          <div className="flex justify-end gap-3 pt-4" data-id="element-1637">
            <Button variant="flat" color="default" onClick={() => setShowObjectivesModal(false)} data-id="element-1638">
              Annulla
            </Button>
            <Button onClick={() => setShowObjectivesModal(false)} data-id="element-1639">Salva</Button>
          </div>
        </div>
      </Modal>

      {/* Deadline View Modal */}
      <Modal isOpen={showDeadlineViewModal} onClose={() => setShowDeadlineViewModal(false)} title="Dettaglio scadenza" size="md" data-id="element-1640">
        {selectedDeadline && <div className="space-y-6" data-id="element-1641">
            <div className="grid grid-cols-2 gap-4" data-id="element-1642">
              <div data-id="element-1643">
                <span className="text-xs font-semibold text-slate-400 uppercase" data-id="element-1644">
                  Titolo
                </span>
                <p className="font-medium" data-id="element-1645">{selectedDeadline.title}</p>
              </div>
              <div data-id="element-1646">
                <span className="text-xs font-semibold text-slate-400 uppercase" data-id="element-1647">
                  Priorità
                </span>
                <div className="mt-1" data-id="element-1648">
                  <Badge variant={selectedDeadline.priority === 'high' ? 'danger' : selectedDeadline.priority === 'medium' ? 'warning' : 'info'} data-id="element-1649">
                    {selectedDeadline.priority === 'high' ? 'Alta' : selectedDeadline.priority === 'medium' ? 'Media' : 'Bassa'}
                  </Badge>
                </div>
              </div>
              <div data-id="element-1650">
                <span className="text-xs font-semibold text-slate-400 uppercase" data-id="element-1651">
                  Cliente
                </span>
                <p className="font-medium" data-id="element-1652">{selectedDeadline.client}</p>
              </div>
              <div data-id="element-1653">
                <span className="text-xs font-semibold text-slate-400 uppercase" data-id="element-1654">
                  Data
                </span>
                <p className="font-medium" data-id="element-1655">{selectedDeadline.date}</p>
              </div>
            </div>
            <div className="flex justify-end gap-3 pt-4 border-t border-slate-100" data-id="element-1656">
              <Button variant="flat" color="default" onClick={() => setShowDeadlineViewModal(false)} data-id="element-1657">
                Chiudi
              </Button>
              <Button onClick={() => {
            setShowDeadlineViewModal(false);
            setShowDeadlineEditModal(true);
          }} startContent={<Edit className="h-4 w-4" data-id="element-1659" />} data-id="element-1658">
                Modifica
              </Button>
            </div>
          </div>}
      </Modal>

      {/* Deadline Edit Modal */}
      <Modal isOpen={showDeadlineEditModal} onClose={() => setShowDeadlineEditModal(false)} title="Modifica scadenza" size="md" data-id="element-1660">
        {selectedDeadline && <div className="space-y-6" data-id="element-1661">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-1662">
              <Input label="Titolo" defaultValue={selectedDeadline.title} required data-id="element-1663" />
              <Input label="Cliente" defaultValue={selectedDeadline.client} required data-id="element-1664" />
              <Input label="Data" type="date" required data-id="element-1665" />
              <Select label="Priorità" defaultValue={selectedDeadline.priority} options={[{
            value: 'high',
            label: 'Alta'
          }, {
            value: 'medium',
            label: 'Media'
          }, {
            value: 'low',
            label: 'Bassa'
          }]} required data-id="element-1666" />
            </div>
            <div className="flex justify-end gap-3 pt-4 border-t border-slate-100" data-id="element-1667">
              <Button variant="flat" color="default" onClick={() => setShowDeadlineEditModal(false)} data-id="element-1668">
                Annulla
              </Button>
              <Button onClick={() => setShowDeadlineEditModal(false)} data-id="element-1669">
                Salva
              </Button>
            </div>
          </div>}
      </Modal>

      {/* Delete Confirmation Modal */}
      <Modal isOpen={showDeleteConfirm} onClose={() => setShowDeleteConfirm(false)} title="Conferma eliminazione" size="sm" data-id="element-1670">
        <div className="space-y-6" data-id="element-1671">
          <div className="bg-red-50 p-4 rounded-lg border border-red-100 flex gap-3" data-id="element-1672">
            <AlertCircle className="h-5 w-5 text-red-600 flex-shrink-0" data-id="element-1673" />
            <p className="text-sm text-red-700" data-id="element-1674">
              Attenzione: questa azione è irreversibile. La scadenza verrà
              eliminata definitivamente.
            </p>
          </div>
          <div className="flex justify-end gap-3 pt-4" data-id="element-1675">
            <Button variant="flat" color="default" onClick={() => setShowDeleteConfirm(false)} data-id="element-1676">
              Annulla
            </Button>
            <Button color="danger" onClick={() => setShowDeleteConfirm(false)} data-id="element-1677">
              Elimina
            </Button>
          </div>
        </div>
      </Modal>
    </Layout>;
}